<template lang="pug">
  footer.footer
    //- ul.row.footer-menu
      li
        span.footer-menu__item(@click="toLink(foregnUrlPages('offer-contract'), '_blank')")
          | {{$t('msgs.terms')}}
      li
        span.footer-menu__item(@click="toLink(foregnUrlPages('privacy'), '_blank')")
          | {{$t('msgs.policy')}}
      li
        span.footer-menu__item(@click="toLink(foregnUrlPages('howtobuy'), '_blank')")
          | {{$t('msgs.howTo')}}
      li
        span.footer-menu__item(@click="toLink(foregnUrlPages('corp'), '_blank')")
          | {{$t('msgs.corps')}}
      li
        a.footer-menu__item(href="https://24guru.by/pages/fororganizer", target="_blank")
          | {{ $t('footer.org') }}
      li
        span.footer-menu__item(@click="toLink(foregnUrlPages('support'), '_blank')")
          | {{$t('msgs.aboutUs')}}
    //- .row.footer-second-line
      .left
        //- a.button.button__icon.button__icon_left(href="//m.24guru.by")
          icon(name="mobile")
          span {{$t('msgs.mobVersion')}}
        a.button.button__icon.button__icon_left(v-if="phone", :href="'tel:' + phone")
          icon(name="phone")
          span {{ phone }}

      .right
        .button__dd
          .button.button__outline.button__gray.button__icon_right
            span {{currentLang}}
            icon(name="downArrow")
          .button__dd_child.toup-dd
            .button__dd_child_scroll
              template(v-for="lng in langs")
                nuxt-link.button__dd_child_item.wsn(
                  :to="switchLocalePath(lng.code)"
                ) {{ lng.name }}
        span.social
          span.social__item(@click="toLink('https://vk.com/24afishaby', '_blank')")
            icon(name="vk")
          span.social__item(@click="toLink('https://www.facebook.com/24afisha.by', '_blank')")
            icon(name="fb")
          span.social__item(@click="toLink('https://www.instagram.com/24afisha.by', '_blank')")
            icon(name="instagram")
    .container
      div.footer-nav__wrapper(v-if="this.$store.state.layout && this.$store.state.layout.footer")
        div(v-for="category in footerByLocale(this.$store.state.layout)", v-if="category.children.length > 0")
          .footer-nav__title {{ category.name }}
          ul.footer-nav
            li(v-for="i in category.children")
              a(v-bind:href="isAfishaDomain ? i.url : 'https://guru.ge' + i.url") {{ i.name }}
        .auth(v-if="isAfishaDomain" @click="showLoginWindow()") {{$t('msgs.loginToAccount')}}
    .copyright
      p.copyright__item(v-if="copyright") {{ copyright }}
      p.copyright__item(v-if="address", v-html="address")
      .payment-logos
        .img-all(v-if="isAfishaDomain")
        .img-all-ge(v-else)
        //.img-erip

</template>

<script>
import icon from 'components@/icons';

export default {
  components: {
    icon,
  },
  data: () => ({
    isAfishaDomain: true,
  }),
  computed: {
    langs() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.langs;
      }
      return [];
    },
    copyright() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.copyright;
      }
      return 'Layout on null';
    },
    phone() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.phone;
      }
      return 'Layout of null';
    },
    address() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.bank.info;
      }
      return 'Layout of null';
    },
    currentLang() {
      return this.$store.state.locale;
    },
    metaImage() {
      return this.$store.state.layout ? this.$store.state.layout.logoUrl : null;
    },
    region() {
      if (this.$store.state.cities.currentCity && this.$store.state.cities.currentCity.slug) {
        return this.$store.state.cities.currentCity.slug;
      }
      return this.$store.state.cities.defaultSlug;
    },
    lang() {
      return this.$store.state.locale;
    },
  },
  mounted() {
    if (window.location.href.match(/localhost/) || window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
  },
  methods: {
    switchLang(newLocale) {
      // change locale in store
      this.$store.commit('SET_LANG', newLocale);
    },
    toLink(link, target) {
      if (window) {
        window.open(link, target);
      }
    },
    foregnUrlPages(slug) {
      let isProd = false;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      const current = isProd ? 'https://24guru.by' : 'http://24.arcom.of.by';
      return `${current}/${this.lang}/pages/${slug}`;
    },
    showLoginWindow() {
      let isProd = false;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      if (this.lActive) {
        window.location.href = isProd ? 'https://cabinet.24afisha.by' : 'http://cabinet.24.24guru.by';
        return;
      }
      this.$store.commit('popup/login', true);
    },
    footerByLocale(layout) {
      if (layout[`footer_${(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru')}`]) {
        return layout[`footer_${(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru')}`].bottom;
      }
      return layout.footer.bottom;
    }
  },
  jsonld() {
    if (this.isAfishaDomain) {
      return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '24guru',
        legalName: 'ООО Эрком Групп',
        url: 'https://24guru.by',
        logo: this.metaImage,
        foundingDate: '2012',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Республика Беларусь, город Минск, улица Пушкина, 39',
          addressLocality: 'Минск',
          addressRegion: 'Минск',
          postalCode: '220092',
          addressCountry: 'BY',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'technical support',
          telephone: '[+375256038743]',
          email: 'support@arcom.group',
        },
        sameAs: [
          'https://vk.com/24afishaby/',
          'https://www.facebook.com/24afisha.by/',
          'https://www.instagram.com/24afisha.by/',
        ],
      };
    }
    return {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Guru.ge",
      legalName: "Guru LLC",
      url: "https://guru.ge",
      logo: "https://guru.ge/_nuxt/img/78c88aa.png",
      foundingDate: "2017",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Tbilisi, Georgia",
        addressLocality: "Tbilisi",
        addressRegion: "Tbilisi",
        postalCode: "0119",
        addressCountry: "GE"
      },
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "Sales",
        telephone: "[+995322422258]",
        email: "sales@guru.ge"
      },
      sameAs: [
        "https://www.facebook.com/gurugroupgeorgia",
        "https://www.instagram.com/guru.ge"
      ]
    }
  },
};
</script>

<style lang="scss">
.copyright {
  position: relative;
  .copyright__item {
    max-width: 56%;
  }
}
.payment-logos {
  @media screen and (min-width: 860px){
    position: absolute;
  }
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  .img-all {
    background-image: url('./images/all.png');
    background-size: contain;
    width: 408px;
    height: 40px;
    background-repeat: no-repeat;
  }
  .img-all-ge {
    background-image: url('./images/all_ge.png');
    background-size: contain;
    width: 140px;
    height: 40px;
    background-repeat: no-repeat;
  }
  .img-erip {
    background-image: url('./images/logo-erip.png');
    background-size: contain;
    width: 30px;
    height: 20px;
  }
}
.footer {
  background-color: #f2f2f2;
  margin: 0;
  padding: 0 1.25rem;
}
.footer-nav__wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 3rem 0;
  list-style: none;
  justify-content: space-between;
}
.footer-nav__title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 1rem;
}
.footer-nav {
  line-height: 2rem;
}
.footer-nav li a {
  font-size: 12px;
  text-decoration: none;
}
@media screen and (max-width: 60rem) {
  .copyright {
    display: flex;
    flex-direction: column-reverse;
  }
  .auth {
    position: absolute;
    margin-top: -1.5rem !important;
  }
  .footer-nav__title {
    margin-top: 4rem;
  }
  .footer-nav__wrapper {
    flex-direction: column;
  }
}
.auth {
  // display: inline-block !important;
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 120px;
  background-color: #fff;
  border-radius: 8px;
  font-size: 12px;
  text-align: center;
  padding: 8px;
  font-weight: 600;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  cursor: pointer;
  margin-top: -8px;
  transition: .5s;
}
.auth:hover {
  box-shadow: none;
}
</style>
